<template lang="pug">
  div(:class="`container-${this._uid} ${this.payload.fields.templateId} ${this.classes}`")
    h1(class="section-title")
      vue-markdown(:source='this.title')
    vue-markdown(:source='this.desc')

    div(class="section-content")
      section.row(v-for="(n, i) in this.payload.fields.content" :class="n.fields.classes")
        component(v-if="!n.sys.contentType.sys.id === 'collection'" is="n.fields.templateId" :payload="n.fields")
        component(v-if="n.sys.contentType.sys.id === 'collection'" is="Collection" :payload="n.fields")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/_sectionBase.js'
import Collection from '@/components/collection'

// component instance
var specialPeopleListing = Vue.component('special-people-listing', {
  name: 'specialPeopleListing',
  mixins: [sectionBase],
  components: { Collection },
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default specialPeopleListing
</script>

<style lang="scss" scoped>
.row .row:first-child{
  padding-top: measure(ml);
}
  .page-title{

  }
  .image{
    width: 210px;
    height: 210px;
    text-align: center;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/special/peopleListing.vue